import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Grid } from '@mui/material';
import HeaderTable from './HeaderTable';
import StepDetailsModalWrapper from './stepDetailsForm/stepDetailsForms/StepDetailsModalWrapper';
import AddHeaderModelContent from './AddHeaderModelContent';
import AddIcon from '@mui/icons-material/Add';

const AddHeadersForm = ({
  setOpenHeaderModal,
  openHeaderModal,
  headers,
  setHeaders,
  edit,
  setEdit,
  alertWebhook,
  alertCondition,
  setAlertCondition,
  alertWebhookAuthType,
  environment
}) => {
  const [headerKey, setHeaderKey] = useState('');
  const [headerValue, setHeaderValue] = useState('');
  const [objectToEdit, setObjectToEdit] = useState('');

  const handleHeaders = (e, header, deleteEntry) => {
    const reset = () => {
      setHeaderKey('');
      setHeaderValue('');
      setOpenHeaderModal(false);
    };

    if (edit) {
      // Update the specific record in the headers array
      const updatedHeaders = headers.map((h) =>
        h.key === objectToEdit.key ? { key: headerKey, value: headerValue } : h
      );

      setHeaders(updatedHeaders);
      setEdit(false);
      setObjectToEdit(null);

      setAlertCondition((alertCondition) => ({
        ...alertCondition,
        headers: updatedHeaders
      }));

      reset();
    } else if (deleteEntry) {
      const updatedHeaders = headers.filter((h) => h.key !== header.key);
      setHeaders(updatedHeaders);

      setAlertCondition((alertCondition) => ({
        ...alertCondition,
        headers: updatedHeaders
      }));
    } else {
      const newHeader = { key: headerKey, value: headerValue };
      const updatedHeaders = [...headers, newHeader];

      setHeaders(updatedHeaders);
      setAlertCondition((alertCondition) => ({
        ...alertCondition,
        headers: updatedHeaders
      }));

      reset();
    }
  };

  const setFormStateOnEdit = (e, headerKey, headerValue) => {
    setHeaderKey(headerKey);
    setHeaderValue(headerValue);
    setEdit(true);
    setOpenHeaderModal(true);
    setObjectToEdit({ key: headerKey, value: headerValue });
  };

  return (
    <>
      <Grid sx={{ display: 'flex', justifyContent: 'end', mb: '1rem' }}>
        {openHeaderModal && (
          <StepDetailsModalWrapper
            open={openHeaderModal}
            edit={edit}
            objectToEdit={objectToEdit}
            title="Headers"
            handleSubmit={handleHeaders}
            handleCancel={(e) => {
              e.preventDefault();
              setOpenHeaderModal(false);
            }}>
            <AddHeaderModelContent
              headerKey={headerKey}
              setHeaderKey={setHeaderKey}
              headerValue={headerValue}
              setHeaderValue={setHeaderValue}
            />
          </StepDetailsModalWrapper>
        )}
      </Grid>
      <Grid sx={{ display: 'flex', justifyContent: 'end', mb: !environment ? '1rem' : 0 }}>
        <Button
          variant={!environment ? 'outlined' : 'text'}
          disabled={
            !alertCondition?.type ||
            !alertCondition?.threshold ||
            !alertWebhook ||
            alertWebhookAuthType != 'STATIC_TOKEN'
          }
          onClick={(e) => {
            e.preventDefault();
            setEdit(false);
            setOpenHeaderModal(true);
          }}
          sx={{ mr: 0 }}>
          <AddIcon />
          Add Header
        </Button>
      </Grid>
      <HeaderTable
        headers={headers}
        setFormStateOnEdit={setFormStateOnEdit}
        handleHeaders={handleHeaders}
      />
    </>
  );
};

AddHeadersForm.propTypes = {
  setOpenHeaderModal: PropTypes.func.isRequired,
  openHeaderModal: PropTypes.bool.isRequired,
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  setHeaders: PropTypes.func.isRequired,
  edit: PropTypes.bool.isRequired,
  setEdit: PropTypes.func.isRequired,
  alertWebhook: PropTypes.string.isRequired,
  alertCondition: PropTypes.shape({
    type: PropTypes.string,
    threshold: PropTypes.number,
    headers: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.string
      })
    )
  }).isRequired,
  setAlertCondition: PropTypes.func.isRequired,
  alertWebhookAuthType: PropTypes.string.isRequired,
  environment: PropTypes.bool
};

export default AddHeadersForm;
